// src/components/dictionary/CategoryGrid.jsx

import React from 'react';
import { ChevronRight } from 'lucide-react';

const CATEGORIES = [
  {
    id: 'marfuat',
    title: "Marfu'at",
    count: 18,
    gradient: 'from-emerald-400 to-emerald-600',
    bgColor: 'bg-emerald-50 dark:bg-emerald-900/20',
    borderColor: 'border-emerald-200 dark:border-emerald-800/40',
    countBg: 'bg-emerald-500',
  },
  {
    id: 'manshubat',
    title: 'Manshubat',
    count: 15,
    gradient: 'from-orange-400 to-orange-600',
    bgColor: 'bg-orange-50 dark:bg-orange-900/20',
    borderColor: 'border-orange-200 dark:border-orange-800/40',
    countBg: 'bg-orange-500',
  },
  {
    id: 'majrurat',
    title: 'Majrurat',
    count: 12,
    gradient: 'from-purple-400 to-purple-600',
    bgColor: 'bg-purple-50 dark:bg-purple-900/20',
    borderColor: 'border-purple-200 dark:border-purple-800/40',
    countBg: 'bg-purple-500',
  },
  {
    id: 'huruf',
    title: 'Huruf',
    count: 10,
    gradient: 'from-sky-400 to-sky-600',
    bgColor: 'bg-sky-50 dark:bg-sky-900/20',
    borderColor: 'border-sky-200 dark:border-sky-800/40',
    countBg: 'bg-sky-500',
  },
  {
    id: 'fiil',
    title: "Fi'il",
    count: 8,
    gradient: 'from-teal-400 to-teal-600',
    bgColor: 'bg-teal-50 dark:bg-teal-900/20',
    borderColor: 'border-teal-200 dark:border-teal-800/40',
    countBg: 'bg-teal-500',
  },
  {
    id: 'sharaf',
    title: 'Sharaf',
    count: 14,
    gradient: 'from-indigo-400 to-indigo-600',
    bgColor: 'bg-indigo-50 dark:bg-indigo-900/20',
    borderColor: 'border-indigo-200 dark:border-indigo-800/40',
    countBg: 'bg-indigo-500',
  },
];

export default function CategoryGrid({ onCategoryClick }) {
  return (
    <div className="px-4 mb-4 animate-fade-in">

      {/* ── Section Header ─────────────────────────── */}
      <div className="flex items-center justify-between mb-3">
        <div>
          <h2 className="text-sm font-extrabold text-slate-800 dark:text-slate-100">
            Kategori Nahwu
          </h2>
          <p className="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">
            Jelajahi istilah berdasarkan kategori
          </p>
        </div>
        <span className="text-[10px] font-bold text-slate-400 dark:text-slate-500 bg-stone-100 dark:bg-slate-800 px-2.5 py-1 rounded-full">
          {CATEGORIES.length} Kategori
        </span>
      </div>

      {/* ── Grid 3 Kolom (seperti referensi) ─────────── */}
      <div className="grid grid-cols-3 gap-2.5">
        {CATEGORIES.map((category, index) => (
          <CategoryCard
            key={category.id}
            category={category}
            onClick={() => onCategoryClick(category.id)}
            delay={index * 0.06}
          />
        ))}
      </div>

    </div>
  );
}

function CategoryCard({ category, onClick, delay }) {
  return (
    <button
      onClick={onClick}
      className={`
        ${category.bgColor} ${category.borderColor}
        border rounded-3xl p-3
        flex flex-col items-start
        hover:scale-[1.04] active:scale-[0.96]
        transition-all duration-200
        shadow-soft
        animate-scale-in
        text-left
      `}
      style={{ animationDelay: `${delay}s` }}
    >
      {/* Atas: Ikon + Badge Count */}
      <div className="flex items-start justify-between w-full mb-3">
        {/* Ikon Emoji dengan Gradien */}
        <div
          className={`
            w-11 h-11 rounded-2xl
            bg-gradient-to-br ${category.gradient}
            flex items-center justify-center
            text-xl shadow-md
          `}
        >
          {category.emoji}
        </div>

        {/* Badge Jumlah */}
        <span
          className={`
            ${category.countBg}
            text-white text-[10px] font-extrabold
            w-6 h-6 rounded-full
            flex items-center justify-center
            shadow-sm flex-shrink-0
          `}
        >
          {category.count}
        </span>
      </div>

      {/* Judul */}
      <p className="text-xs font-extrabold text-slate-800 dark:text-slate-100 leading-tight mb-1">
        {category.title}
      </p>

      {/* Sub-label + Ikon Panah */}
      <div className="flex items-center justify-between w-full">
        <span className="text-[10px] text-slate-500 dark:text-slate-400 font-medium">
          {category.count} Materi
        </span>
        <ChevronRight className="w-3.5 h-3.5 text-slate-400 dark:text-slate-500" />
      </div>
    </button>
  );
}